import React, { useState } from "react";
import "../../assets/css/SalesTrend/SalesTrend.css";
import SalesTrendHeader from "../SalesTrendHeader.tsx";
import SaleStatus from "./component/SalesStatus.js";
import FixedColumnTable from "./component/FixedColumnTable.tsx";
import NewFilterBar from "../SalesTrend/components/NewFilter.js";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";
import { API_BASE_URL } from "../../config/config";

function BrandWiseSalesDashBoard() {
  
const [refreshTime, setRefreshTime] = useState(null);
  const [userLoaction, setuserLocation] = useState(null);
  const [headerUsername, setheaderUsername] = useState(null);

  useTokenFromQuery("/app/salesbyzone_dashboard");
  useFetchUserDetails(setuserLocation, setheaderUsername, setRefreshTime, API_BASE_URL , "SalesByZoneDashboard");
  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();


  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Sales By Zone/ Region/ HQ (Daily)"
          userName={headerUsername}
          location={userLoaction}
          refreshTime={refreshTime}
        />

        <div className="new-filter-bar-sticky">
          <NewFilterBar
            user_id={user_id}
            apiEndpoint="Dashboard/ZoneRegionHQDashboard"
          />
        </div>
        <SaleStatus />
        <FixedColumnTable />
      </div>
    </div>
  );
}

export default BrandWiseSalesDashBoard;
